import { styled } from "@mui/material";

import Modal from "..";

export const EditModal = styled(Modal)(() => ({
  minWidth: "442px",
  maxWidth: "max-content",
}));

export const Body = styled("div")(() => ({
  width: "100%",
  fontFamily: "Manrope !important",
  flex: 1,
  flexDirection: "column",
  paddingBottom: "15px",
  alignItems: "center",
  justifyContent: "center",
}));
